export const SMTP_PASSWORD = "smtp_pass";
export const SMTP_SERVER = "smtp_server";
export const SMTP_LOGIN = "smtp_login";
export const SMTP_PORT = "smtp_port";
export const SMTP_FROM_ADDRESS = "from_addr";
export const SMTP_TO_ADDRESS = "to_addr";

export const ACTION_LOG_ROTATION_PERIOD = "rotation_period";

export const FTP_MASQUERADE_ADDRESS = "masquerade_address";
